import type {ResourceProps} from "@refinedev/core";

/** Refine resource registry — maps to PHP admin API via adminDataProvider */
export const adminResources: ResourceProps[] = [
  {name: "dashboard", list: "/vadmin", meta: {label: "Dashboard"}},
  {name: "integrations", list: "/vadmin/integrari", meta: {label: "Integrations"}},
  {name: "orders", list: "/vadmin/comenzi", meta: {label: "Orders", canDelete: false}},
  {name: "returns", list: "/vadmin/comenzi/returnare", meta: {label: "Returns", parent: "orders"}},
  {name: "vouchers", list: "/vadmin/comenzi/vouchere", meta: {label: "Vouchers", parent: "orders"}},
  {name: "clients", list: "/vadmin/clienti", meta: {label: "Clients"}},
  {name: "client-groups", list: "/vadmin/clienti/grupuri", meta: {label: "Groups", parent: "clients"}},
  {name: "client-notifications", list: "/vadmin/clienti/notificari", meta: {label: "Notifications", parent: "clients"}},
  {name: "products", list: "/vadmin/produse", meta: {label: "Products"}},
  {name: "product-offers", list: "/vadmin/produse/oferte", meta: {label: "Offers", parent: "products"}},
  {name: "product-reviews", list: "/vadmin/produse/recenzii", meta: {label: "Reviews", parent: "products"}},
  {name: "product-shipping", list: "/vadmin/produse/transport", meta: {label: "Shipping", parent: "products"}},
  {name: "cms-pages", list: "/vadmin/continut", meta: {label: "Pages", parent: "continut"}},
  {name: "cms-carousel", list: "/vadmin/continut/carusel", meta: {label: "Carousel", parent: "continut"}},
  {name: "cms-announcements", list: "/vadmin/continut/anunturi", meta: {label: "Announcements", parent: "continut"}},
  {name: "cms-home-boxes", list: "/vadmin/continut/casute", meta: {label: "Boxes", parent: "continut"}},
  {name: "cms-faq", list: "/vadmin/continut/faq", meta: {label: "FAQ", parent: "continut"}},
  {name: "seo", list: "/vadmin/seo", meta: {label: "SEO"}},
  {name: "users", list: "/vadmin/utilizatori", meta: {label: "Users", canDelete: true}},
  {name: "logs", list: "/vadmin/log", meta: {label: "Log", canDelete: false, canCreate: false, canEdit: false}}
];
